import styled from 'styled-components';

export const TopBar = styled.div`
  padding: 1.6rem 2.4rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const Logo = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accentDark};
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  min-height: 0;
  padding: 0 1.6rem 0;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
`;

export const Card = styled.div`
  width: 100%;
  max-width: 60rem;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border-left: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-right: 0.1rem solid ${({ theme }) => theme.colors.border};
  min-height: 0;
`;

export const Header = styled.div`
  padding: 1.6rem 2.4rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const HeaderTitle = styled.div`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const ServiceName = styled.div`
  font-size: 1.3rem;
  font-style: italic;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.4rem;
`;

export const ThreadDate = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateMuted};
  margin-top: 0.4rem;
`;

export const ThreadBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  overflow-y: auto;
  padding: 2rem 2.4rem;
  min-height: 0;
`;

export const Bubble = styled.div<{ $sender: string }>`
  padding: 1.2rem 1.6rem;
  border-radius: 1.2rem;
  background-color: ${({ $sender, theme }) =>
    $sender === 'client' ? theme.colors.surface : theme.colors.accentBgSoft};
  border-left: ${({ $sender, theme }) =>
    $sender === 'provider' ? `0.3rem solid ${theme.colors.accent}` : 'none'};
  max-width: 85%;
  align-self: ${({ $sender }) =>
    $sender === 'client' ? 'flex-end' : 'flex-start'};
`;

export const BubbleSender = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: 0.4rem;
  text-transform: uppercase;
`;

export const BubbleText = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const BubbleTime = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateMuted};
  margin-top: 0.6rem;
`;

export const PhotosRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.8rem;
`;

export const PhotoButton = styled.button`
  display: inline-block;
  line-height: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: zoom-in;
`;

export const PhotoTile = styled.img`
  width: 9rem;
  height: 9rem;
  object-fit: cover;
  border-radius: 0.8rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  transition: transform 0.15s ease;
  &:hover {
    transform: scale(1.02);
  }
`;

export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 2rem;
`;

export const LightboxContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  max-width: 90vw;
  max-height: 92vh;
`;

export const LightboxImage = styled.img`
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 0.6rem;
  box-shadow: 0 0.4rem 2rem rgba(0, 0, 0, 0.6);
`;

export const LightboxActions = styled.div`
  display: flex;
  gap: 1rem;
`;

export const LightboxAction = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 1.6rem;
  border-radius: 999rem;
  border: 0.1rem solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.12);
  color: ${({ theme }) => theme.colors.overlayText};
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  font-family: inherit;
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const Waiting = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.slateMuted};
  font-size: 1.3rem;
  padding: 1.6rem;
`;

export const ReplyBox = styled.div`
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding: 1.2rem 2.4rem;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const SendBtn = styled.button`
  width: 100%;
  border: none;
  border-radius: 1.2rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.accent};
  cursor: pointer;
  margin-top: 0.8rem;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;
